// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ccMw","delete":"styles_delete__2vAT9","update":"styles_update__12UV_","add":"styles_add__iZ_X9"};